module.exports = __webpack_public_path__ + "static/media/ad_botao.7a3150e1.webp";